export default "__VITE_ASSET__CNfeizfw__"